import request from '@/router/axios';

export const getList = (current, size, params, deptId) => request({
  url: '/api/blade-user/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
    deptId,
  },
})
export const getListByProject = (current, size, params, deptId) => request({
  url: '/api/blade-user/pageByProject',
  method: 'get',
  params: {
    ...params,
    current,
    size,
    deptId,
  },
})

export const remove = ids => request({
  url: '/api/blade-user/remove',
  method: 'post',
  params: {
    ids,
  },
})
export const removeByProject = ids => request({
  url: '/api/blade-user/removeByProject',
  method: 'post',
  params: {
    ids,
  },
})

export const add = row => request({
  url: '/api/blade-user/submit',
  method: 'post',
  data: row,
})
export const addByProject = row => request({
  url: '/api/blade-user/submitByProject',
  method: 'post',
  data: row,
})

export const update = row => request({
  url: '/api/blade-user/update',
  method: 'post',
  data: row,
})

export const getUser = id => request({
  url: '/api/blade-user/detail',
  method: 'get',
  params: {
    id,
  },
})

export const getUserInfo = () => request({
  url: '/api/blade-user/info',
  method: 'get',
})

export const resetPassword = userIds => request({
  url: '/api/blade-user/reset-password',
  method: 'post',
  params: {
    userIds,
  },
})

export const updatePassword = (oldPassword, newPassword, newPassword1) => request({
  url: '/api/blade-user/update-password',
  method: 'post',
  params: {
    oldPassword,
    newPassword,
    newPassword1,
  },
})
// 批量添加用户权限
export const addJurisdictionBatch = (userIds, projectId) => request({
  url: '/api/qcdm/project/jurisdiction/batch',
  method: 'post',
  params: {
    projectId,
    userIds,
  },
})
// 单用户权限设置
export const addJurisdictionSingle = (userId, projectIds) => request({
  url: '/api/qcdm/project/jurisdiction/single',
  method: 'post',
  params: {
    projectIds,
    userId,
  },
})
// 获取单用户权限
export const getJurisdictionList = userId => request({
  url: '/api/qcdm/project/jurisdiction/projectList',
  method: 'get',
  meta: {
    doNotAddProjectId: true,
  },
  params: { userId },
})
export const updateInfo = row => request({
  url: '/api/blade-user/update-info',
  method: 'post',
  data: row,
})
